import Vue from 'vue';
import merge from '@/utils/merge';
import preLoadingVue from './preLoading.vue';
let preLoadingConstructor = Vue.extend(preLoadingVue);

const defaults = {
	data: []
};
const preLoading = (options) => {
	options = merge({}, defaults, options);
	let instance = new preLoadingConstructor({
		data: options
	});
	instance._vm = instance.$mount();
	instance._el = instance.$el;
	instance._instance = instance;
	document.body.appendChild(instance.$el); // 把生成的提示的dom插入body中
	return instance;
};
export default preLoading;
